import React from 'react';
import { connect } from 'react-redux';

//Components
import SmartMenu from '../index';
import { DataSourceSlugs } from 'Shared/constants/types';
import { SmartLinkLogo } from '../../components';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import { WpButton } from 'Wpds/components/button';

//Selectors
import { getOnedriveSignUpUrl } from 'Shared/selectors/smartLinks';

//Styles
import '../SmartMenu.scss';

//Helpers
import { trackClickedConnectApp } from 'Shared/tracking/tracking';

const OnedriveSmartMenu = props => {
  const { hasOnedriveIntegration, onedriveSignUpUrl, type, logoName } = props;

  const renderSmartLinkDetail = smartLinkDetail => {
    const { created_by, created_by_avatar } = smartLinkDetail;
    const created_by_initials = created_by
      ? created_by.includes(' ')
        ? created_by.substr(0, 1) + created_by.split(' ')[1].substr(0, 1)
        : created_by.substr(0, 1)
      : '';
    const created_by_display_avatar = created_by_avatar
      ? created_by_avatar
      : { initials: created_by_initials, color: '#57CA8C' };
    const className = 'SmartMenu__content__row';

    return (
      <>
        <div className={className}>
          <div className={`${className}__label`}>Created by:</div>
          <div className={`${className}__value`}>
            {created_by && <WpAvatar size="sm" avatar={created_by_display_avatar} />}
            {!created_by && (
              <span className={`${className}__empty-user-icon`}>
                <WpIcon name="user" size="md" />
              </span>
            )}
            <div className={`${className}__value__text`}>{created_by || 'Unknown'}</div>
          </div>
        </div>
        <a href={smartLinkDetail.url} target="blank" rel="noopener norefferer">
          View in OneDrive / SharePoint
        </a>
      </>
    );
  };

  const handleConnectClick = () => {
    trackClickedConnectApp(DataSourceSlugs.onedrive);
    window.location.href = onedriveSignUpUrl;
  };

  const renderEmbedingContent = () => {
    const className = 'SmartMenu__content__button';
    return (
      <>
        <div className={className}>To see more details about this link, connect your Microsoft Office365 account.</div>
        <p />
        <div className={className}>
          <WpButton variant="tertiary" onClick={handleConnectClick} block>
            Connect OneDrive/SharePoint
          </WpButton>
        </div>
      </>
    );
  };

  const menuTitle = () => (
    <>
      <SmartLinkLogo src={logoName} />
      {type}
    </>
  );

  return (
    <SmartMenu
      hasDocumentIntegration={hasOnedriveIntegration}
      renderEmbedingContent={renderEmbedingContent}
      renderSmartLinkDetail={renderSmartLinkDetail}
      objectName="OneDrive / SharePoint file"
      menuTitle={menuTitle}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  hasOnedriveIntegration: state.data_sources?.find(({ slug }) => slug === DataSourceSlugs.onedrive)?.connected,
  onedriveSignUpUrl: getOnedriveSignUpUrl(state),
});

export default connect(mapStateToProps)(OnedriveSmartMenu);
